<script lang="ts" setup>
import { AppToast } from '@libs/ui';

import type { TripOverviewNofication } from '../models';
import { useTripOverviewNotificationsStore } from '../stores/tripOverviewNotificationsStore';

const notificationStore = useTripOverviewNotificationsStore();

function handleCustomAction(notification: TripOverviewNofication): void {
  switch (notification.customAction?.action) {
    /* case TripOverviewNotificationAction. :
     * action
     * notificationStore.removeNotification(notification);
     */
    default:
      break;
  }
}
</script>

<template>
  <div class="trip-overview-notifications">
    <AppToast
      v-for="(notification, index) of notificationStore.notifications"
      :key="index"
      :message="notification.message"
      :icon="notification.icon"
      :button="notification.customAction"
      :auto-close="notification.autoclose"
      @close-toast="notificationStore.removeNotification(notification)"
      @button-clicked="handleCustomAction(notification)"
    />
  </div>
</template>

<style scoped lang="scss">
.trip-overview-notifications {
  position: fixed;
  bottom: var(--spacing-12);
  z-index: var(--notification-z-index);
  left: 50%;
  transform: translateX(-50%);

  @include for-large-devices-max {
    width: 100%;
  }
}
</style>
